var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.linkType === 'routerLink')?_c('router-link',{class:_vm.className,attrs:{"to":_vm.url}},[_vm._t("default")],2):_c('a',{class:_vm.className,attrs:{"href":_vm.url}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }